export default {
  apiKey:
    process.env.REACT_APP_GOOGLE_CLOUD_API_KEY ||
    'AIzaSyDbPUrpGmaJQM79uwvpwT5rXk81BSLWUgE',
  center: { lat: 59.95, lng: 30.33 },
  zoom: 11
}
